
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iqWjJ", function(module, exports) {

var $2Maq7 = parcelRequire("2Maq7");

const $6dcf901a23b2876f$export$fc883aabd3b0aeb1 = (imageUrl)=>{
    if (!imageUrl) return false;
    return imageUrl?.includes((0, $2Maq7.UNSPLASH_URL));
};
module.exports["isUnsplashImage"] = $6dcf901a23b2876f$export$fc883aabd3b0aeb1;

});

parcelRegister("2Maq7", function(module, exports) {
const $be60834a85e1f9eb$export$fe42ffbf1f8cac0e = 'unsplash';
const $be60834a85e1f9eb$export$9d9758c15e32e47a = 'minimal';
const $be60834a85e1f9eb$export$4eb66a6321d4a29c = 'color';
module.exports["UNSPLASH_URL"] = $be60834a85e1f9eb$export$fe42ffbf1f8cac0e;
module.exports["DEFAULT_UNSPLASH_QUERY_WORD"] = $be60834a85e1f9eb$export$9d9758c15e32e47a;
module.exports["PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD"] = $be60834a85e1f9eb$export$4eb66a6321d4a29c;

});

parcelRegister("jqjsu", function(module, exports) {

var $iqWjJ = parcelRequire("iqWjJ");

const $04a364cca99a3e77$export$25f23b916a7baf7 = ({ imageSrc: imageSrc })=>{
    const isAbsoluteUrl = /^https?:\/\//.test(imageSrc || '');
    const isFileId = !isAbsoluteUrl && Boolean(imageSrc?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!imageSrc && isFileId;
    const showUnsplashImage = !showCustomUploadedImage && (0, $iqWjJ.isUnsplashImage)(imageSrc);
    const showExternalSiteImage = !!imageSrc && !showCustomUploadedImage && !showUnsplashImage;
    return {
        showUnsplashImage: showUnsplashImage,
        showExternalSiteImage: showExternalSiteImage,
        showCustomUploadedImage: showCustomUploadedImage,
        hasImage: showUnsplashImage || showCustomUploadedImage || showExternalSiteImage
    };
};
const $04a364cca99a3e77$export$af23f40d1cee8ded = (url)=>{
    return new Promise((resolve)=>{
        // Creating an image element in memory to verify if the URL is a valid image
        const img = new Image();
        img.onload = ()=>resolve(true);
        img.onerror = ()=>resolve(false);
        img.src = url;
    });
};
const $04a364cca99a3e77$export$6535eb414fa2c8b6 = (url)=>{
    const trimmedUrl = url.trim();
    // If it already has a protocol, return as is
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) return trimmedUrl;
    // If it starts with //, add https:
    if (trimmedUrl.startsWith('//')) return `https:${trimmedUrl}`;
    // Otherwise, add https:// (default to secure)
    return `https://${trimmedUrl}`;
};
const $04a364cca99a3e77$export$bef94a5618bf18bf = (url)=>{
    const trimmedUrl = url.trim();
    // Handle empty strings
    if (!trimmedUrl) return false;
    // Check if it's already a valid URL with protocol
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) try {
        new URL(trimmedUrl);
        return true;
    } catch  {
        return false;
    }
    // For URLs without protocol, check if they look like valid domains
    // This prevents things like "invalid-url" from being normalized to "https://invalid-url"
    if (trimmedUrl.startsWith('//')) {
        // Protocol-relative URLs should have a valid domain after //
        const domainPart = trimmedUrl.substring(2);
        return domainPart.includes('.') && !domainPart.includes(' ');
    }
    // For URLs without protocol, they should look like valid domains
    // Must contain a dot (for domain) and no spaces
    if (trimmedUrl.includes('.') && !trimmedUrl.includes(' ')) // Basic domain validation - should have at least one dot and no spaces
    return true;
    return false;
};
module.exports["getImageTypeToShow"] = $04a364cca99a3e77$export$25f23b916a7baf7;
module.exports["isImageURL"] = $04a364cca99a3e77$export$af23f40d1cee8ded;
module.exports["normalizeUrl"] = $04a364cca99a3e77$export$6535eb414fa2c8b6;
module.exports["isValidUrl"] = $04a364cca99a3e77$export$bef94a5618bf18bf;

});

parcelRegister("evEMm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");


var $kHNfU = parcelRequire("kHNfU");


var $jqjsu = parcelRequire("jqjsu");

const $2382e5b60fce93fb$var$unboundedStyles = {
    image: "_4t3i1osq _1bsb1osq _5ral1dfr"
};
const $2382e5b60fce93fb$export$a8e6523ab063becd = ({ contentId: contentId, imageSrc: imageSrc, imageAlt: imageAlt, shouldShowExternalSiteImage: shouldShowExternalSiteImage, customMediaAuthProvider: customMediaAuthProvider, customCollectionId: customCollectionId })=>{
    const { experienceSuccessComponent: experienceSuccessComponent } = (0, $fOKpq.useProductDependencies)();
    if (!imageSrc) return null;
    const { showUnsplashImage: showUnsplashImage, showCustomUploadedImage: showCustomUploadedImage, showExternalSiteImage: showExternalSiteImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    if (showUnsplashImage || shouldShowExternalSiteImage && showExternalSiteImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        "data-testid": "img-element",
        alt: imageAlt,
        src: imageSrc,
        className: (0, $gMc0m.default)([
            $2382e5b60fce93fb$var$unboundedStyles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ExperienceSuccessComponent, null));
    else if (showCustomUploadedImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kHNfU.CustomImageUploadRenderer), {
        contentId: contentId,
        imageSrc: imageSrc,
        imageAltText: imageAlt,
        shouldShowErrorMessage: true,
        mediaConfigOverride: {
            collection: customCollectionId,
            authProvider: customMediaAuthProvider
        }
    });
    // Fallback if nothing matches
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ExperienceSuccessComponent, null);
};
module.exports["ImageRenderer"] = $2382e5b60fce93fb$export$a8e6523ab063becd;

});

parcelRegister("kHNfU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $ebrpi = parcelRequire("ebrpi");


var $3rvSa = parcelRequire("3rvSa");


var $btHGY = parcelRequire("btHGY");


var $gdv5Z = parcelRequire("gdv5Z");


var $fwDOR = parcelRequire("fwDOR");


var $fOKpq = parcelRequire("fOKpq");




const $08582f179b34db1b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    imageFailedMessage: {
        id: "company-hub.company-hub-common.link-cards.image-failed-to-load",
        defaultMessage: "Image failed to load"
    },
    warningIcon: {
        id: "company-hub.company-hub-common.link-cards.warning",
        defaultMessage: "Warning icon for image failed to load"
    }
});


const $c37331190ee2a568$var$IMAGE_CONFIGURATION = {
    allowAnimated: true,
    mode: 'fit',
    upscale: false
};
const $c37331190ee2a568$var$styles = {
    loading: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o _bfhkysee",
    errorWrapper: "_1e0c1txw _2lx21bp4 _1bsb1osq _4t3i1osq _1bah1h6o _4cvr1h6o _bfhkysee",
    image: "_4t3i1osq _1bsb1osq _1h1tn7od _5ral1dfr"
};
const $c37331190ee2a568$export$3f3413d4a48facf = ({ contentId: contentId, imageSrc: imageSrc = '', imageAltText: imageAltText, mediaConfigOverride: mediaConfigOverride, shouldShowErrorMessage: shouldShowErrorMessage = false })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent, useMediaConfig: useMediaConfig } = (0, $fOKpq.useProductDependencies)();
    const { authProvider: authProvider, collection: collection, fileId: fileId } = useMediaConfig?.({
        contentId: contentId,
        imageSrc: imageSrc
    }) || {};
    const resolvedAuthProvider = mediaConfigOverride?.authProvider ?? authProvider;
    const resolvedCollectionName = mediaConfigOverride?.collection ?? collection;
    const identifier = (0, $42omo.useMemo)(()=>({
            mediaItemType: 'file',
            id: fileId ?? '',
            collectionName: resolvedCollectionName ?? ''
        }), [
        fileId,
        resolvedCollectionName
    ]);
    if (!resolvedAuthProvider || !resolvedCollectionName || !imageSrc) return null;
    const errorState = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $c37331190ee2a568$var$styles.errorWrapper,
        testId: "custom-image-upload-error"
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: intl.formatMessage((0, $08582f179b34db1b$export$defe85febe8b728c).warningIcon),
        color: "var(--ds-icon-subtle, #505258)"
    }), shouldShowErrorMessage && /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $08582f179b34db1b$export$defe85febe8b728c).imageFailedMessage));
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    return /*#__PURE__*/ $42omo.createElement((0, $3rvSa.MediaClientProvider), {
        clientConfig: {
            authProvider: resolvedAuthProvider
        }
    }, /*#__PURE__*/ $42omo.createElement((0, $btHGY.MediaImageWithErrorBoundary), {
        identifier: identifier,
        key: fileId,
        mediaClientConfig: {
            authProvider: resolvedAuthProvider
        },
        apiConfig: $c37331190ee2a568$var$IMAGE_CONFIGURATION
    }, ({ data: data, loading: loading, error: error })=>{
        if (loading) return /*#__PURE__*/ $42omo.createElement((0, $fwDOR.default), {
            name: "custom-uploaded-image-loading"
        }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            testId: "custom-image-upload-loading",
            xcss: $c37331190ee2a568$var$styles.loading
        }));
        if (error || !data?.src) return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, errorState, /*#__PURE__*/ $42omo.createElement(ExperienceError, {
            error: new Error('Image failed to load in CustomImageUploadRenderer')
        }));
        return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement("img", {
            src: data.src,
            alt: imageAltText,
            "data-testid": "custom-image-upload",
            className: (0, $gMc0m.default)([
                $c37331190ee2a568$var$styles.image
            ])
        }), /*#__PURE__*/ $42omo.createElement(ExperienceSuccess, null));
    }));
};
module.exports["CustomImageUploadRenderer"] = $c37331190ee2a568$export$3f3413d4a48facf;

});

parcelRegister("3VSZJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $19TyP = parcelRequire("19TyP");


var $fOKpq = parcelRequire("fOKpq");


var $4cOi8 = parcelRequire("4cOi8");

/**
 * Validates and sanitizes a URL to prevent XSS attacks.
 *
 * @param url - The URL to validate and sanitize
 * @returns The sanitized URL or empty string if unsafe
 *
 */ const $c5a2fd796ef2ffd2$export$a5e3d4c760ae8d05 = (url)=>{
    if (!url || typeof url !== 'string') return '';
    url = url.trim();
    try {
        // In case of SSR, global window may not have been initialized
        const baseUrl = typeof window !== 'undefined' ? window.location.origin : undefined;
        const parsed = new URL(url, baseUrl);
        if (![
            'http:',
            'https:',
            'mailto:',
            'tel:'
        ].includes(parsed.protocol)) return '';
        return parsed.href;
    } catch  {
        return '';
    }
};



var $1A6sR = parcelRequire("1A6sR");




const $3a5c440fe3fe67ab$var$_default_1 = (0, $aXWIB.defineMessages)({
    placeholderButtonLabel: {
        id: "company-hub.company-hub-common.spotlight.button-label.placeholder",
        defaultMessage: "View"
    }
});
var $3a5c440fe3fe67ab$export$2e2bcd8739ae039 = $3a5c440fe3fe67ab$var$_default_1;


const $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS = {
    small: 640,
    medium: 1400
};
const $25abfcac2f4d9a9e$var$styles = {
    baseWrapperStyles: "_4t3i1osq",
    smallStyles: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    mediumStyles: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    largeStyles: "_ca0qxncg _u5f3xncg _n3tdxncg _19bvxncg",
    largeTitle: "_11c810sd",
    xlargeTitle: "_11c812ln",
    xxlargeTitle: "_11c81iff",
    titleStyles: "_k48p1pd9",
    smallFrameStyles: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    mediumFrameStyles: "_ca0q1ejb _n3td1ejb _19bvxy5q _u5f3xy5q",
    largeFrameStyles: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $25abfcac2f4d9a9e$export$c2176a81b9d23a65 = (width, layout)=>{
    if (layout === (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE) {
        if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallFrameStyles';
        if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumFrameStyles';
        return 'largeFrameStyles';
    }
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallStyles';
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumStyles';
    return 'largeStyles';
};
const $25abfcac2f4d9a9e$var$baseButtonStyles = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "5px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-small, 5px)",
    transition: 'background 0.1s ease-out',
    borderStyle: 'solid',
    borderColor: 'color.border',
    paddingBlock: 'space.100',
    paddingInline: 'space.150',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    }
});
const $25abfcac2f4d9a9e$var$defaultButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.overlay.pressed'
    }
});
const $25abfcac2f4d9a9e$var$alternativeButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    ':hover': {
        backgroundColor: 'color.background.neutral.bold.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.bold.pressed'
    }
});
const $25abfcac2f4d9a9e$var$getTitleFontSize = (width)=>{
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'largeTitle';
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'xlargeTitle';
    return 'xxlargeTitle';
};
const $25abfcac2f4d9a9e$var$getDescriptionSize = (width)=>{
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'medium';
    return 'large';
};
const $25abfcac2f4d9a9e$var$getBaseLineCount = (isSplitLayout, width)=>{
    if (!isSplitLayout) return 8;
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 3;
    return 6;
};
const $25abfcac2f4d9a9e$var$getDescriptionMaxLines = (isSplitLayout, width, isButtonShown)=>{
    const lines = $25abfcac2f4d9a9e$var$getBaseLineCount(isSplitLayout, width);
    return isButtonShown ? lines - 2 : lines;
};
const $25abfcac2f4d9a9e$export$e0b309a29dbe6cbc = ({ testId: testId, width: width = (0, $1A6sR.VERTICAL_MAX_WIDTH) + 1, layout: layout, textColor: savedTextColor, title: title, description: description, isButtonShown: isButtonShown, buttonText: buttonText, link: link, buttonStyle: buttonStyle, source: source, imageWidthPercentage: imageWidthPercentage = 0.5 })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const isSplitLayout = layout !== (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND && layout !== (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE;
    const isDefaultButtonStyle = buttonStyle === (0, $4cOi8.ButtonStyle).DEFAULT;
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor } = (0, $19TyP.useDarkModeColors)(isSSRProductInDarkMode);
    const textColor = getDarkModeCompatibleTextColor(savedTextColor);
    const handleButtonClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spotlightButton',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const bodyTextMaxLines = (0, $42omo.useMemo)(()=>$25abfcac2f4d9a9e$var$getDescriptionMaxLines(isSplitLayout, width, isButtonShown), [
        isSplitLayout,
        width,
        isButtonShown
    ]);
    const titleMaxLines = ()=>{
        if (!description) return 5;
        if (imageWidthPercentage > 0.5 && width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 2;
        return 3;
    };
    const safeUrl = (0, $c5a2fd796ef2ffd2$export$a5e3d4c760ae8d05)(link);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        space: width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small ? 'space.150' : 'space.200',
        alignInline: "start",
        alignBlock: "center",
        xcss: (0, $1Whri.cx)($25abfcac2f4d9a9e$var$styles.baseWrapperStyles, $25abfcac2f4d9a9e$var$styles[$25abfcac2f4d9a9e$export$c2176a81b9d23a65(width, layout)]),
        testId: testId
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        align: "start",
        color: "inherit",
        maxLines: titleMaxLines(),
        testId: "spotlight-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ), {
        style: {
            color: textColor
        },
        xcss: (0, $1Whri.cx)($25abfcac2f4d9a9e$var$styles[$25abfcac2f4d9a9e$var$getTitleFontSize(width)], $25abfcac2f4d9a9e$var$styles.titleStyles)
    }, title)), description && bodyTextMaxLines > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            color: textColor
        },
        "data-vc": "fhCisTPN"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        testId: "spotlight-description",
        align: "start",
        color: "inherit",
        size: $25abfcac2f4d9a9e$var$getDescriptionSize(width),
        maxLines: bodyTextMaxLines
    }, description)), isButtonShown && safeUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        onClick: handleButtonClick,
        href: safeUrl,
        xcss: [
            $25abfcac2f4d9a9e$var$baseButtonStyles,
            isDefaultButtonStyle ? $25abfcac2f4d9a9e$var$defaultButtonStyles : $25abfcac2f4d9a9e$var$alternativeButtonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "medium",
        color: isDefaultButtonStyle ? 'color.text' : 'color.text.inverse',
        maxLines: 1
    }, buttonText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3a5c440fe3fe67ab$export$2e2bcd8739ae039).placeholderButtonLabel))));
};
module.exports["SpotlightContent"] = $25abfcac2f4d9a9e$export$e0b309a29dbe6cbc;

});

parcelRegister("1A6sR", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $19TyP = parcelRequire("19TyP");


var $fOKpq = parcelRequire("fOKpq");


var $4cOi8 = parcelRequire("4cOi8");

const { NO_IMAGE_BACKGROUND: $dc61fe5bc723aa83$var$NO_IMAGE_BACKGROUND, SPLIT_IMAGE_LEFT: $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT, SPLIT_IMAGE_RIGHT: $dc61fe5bc723aa83$var$SPLIT_IMAGE_RIGHT, FRAME_ABOVE_IMAGE: $dc61fe5bc723aa83$var$FRAME_ABOVE_IMAGE } = (0, $4cOi8.CommonLayout); /**
                   * The maximum width in pixels at which the layout is oriented vertically, at larger widths it is horizontal.
                   */ 
const $dc61fe5bc723aa83$export$a24d4999f7186564 = 640;
const $dc61fe5bc723aa83$var$FRAME_MAX_WIDTH = 486;
const $dc61fe5bc723aa83$var$CENTERED_FRAME_WIDTH = 364;
const $dc61fe5bc723aa83$var$WIDE_FRAME_WIDTH = 393;
const $dc61fe5bc723aa83$var$FULL_WIDTH_FRAME_WIDTH = 512;
const $dc61fe5bc723aa83$var$percentageStyles = {
    flex: "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq",
    imageSide: "_16jlidpf _1o9zidpf",
    childrenSide: "_16jlkb7n",
    borderStyle: "_19itia51"
};
const $dc61fe5bc723aa83$var$gridStyles = {
    grid: "_1e0c11p5 _4t3i1osq _2z051n6q",
    frameChildren: "_2rko1mok _yyhy183o _1ii7iqaa _195gxy5q",
    fullImage: "_1reo15vq _18m915vq _19itia51 _yyhyjvu9 _1ii7jvu9 _4t3i1osq",
    roundedBorderRadius: "_2rkopb1k",
    smallFrameStyling: "_195gpxbi _p12f9mso",
    centeredFrameStyling: "_195gxy5q _1bsb1dty _p12f9mso",
    wideFrameStyling: "_195gxy5q _1bsb1m8p _p12f9mso",
    fullWidthFrameStyling: "_195gxncg _1bsb9k2i"
};
function $dc61fe5bc723aa83$var$spotlightToCssHeight(height) {
    switch(height){
        case (0, $4cOi8.Height).SMALL:
            return 248;
        case (0, $4cOi8.Height).MEDIUM:
            return 400;
        case (0, $4cOi8.Height).LARGE:
        default:
            return 620;
    }
}
var $dc61fe5bc723aa83$export$262fb604e10a6da8 = /*#__PURE__*/ function(SpotlightWidth) {
    SpotlightWidth[SpotlightWidth["SMALL"] = 356] = "SMALL";
    SpotlightWidth[SpotlightWidth["CENTERED"] = 800] = "CENTERED";
    SpotlightWidth[SpotlightWidth["WIDE"] = 1050] = "WIDE";
    SpotlightWidth[SpotlightWidth["FULL_WIDTH"] = 1840] = "FULL_WIDTH";
    return SpotlightWidth;
}({});
function $dc61fe5bc723aa83$export$e2db3adb05a4002(width) {
    if (width <= 356) return 'smallFrameStyling';
    if (width <= 800) return 'centeredFrameStyling';
    if (width <= 1050) return 'wideFrameStyling';
    return 'fullWidthFrameStyling';
}
function $dc61fe5bc723aa83$export$40cf3f2715085991({ backgroundColor: savedBackgroundColor, children: children, height: height, image: image, layout: layout, testId: testId, width: width = $dc61fe5bc723aa83$export$a24d4999f7186564 + 1, imageWidthPercentage: imageWidthPercentage = 0.5, hasRoundedCorners: hasRoundedCorners }) {
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, hideExtensionBorders: hideExtensionBorders } = (0, $fOKpq.useProductDependencies)();
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $19TyP.useDarkModeColors)(isSSRProductInDarkMode);
    const backgroundColor = getDarkModeCompatibleBackgroundColor(savedBackgroundColor);
    if (!image) layout = $dc61fe5bc723aa83$var$NO_IMAGE_BACKGROUND;
    const showVerticalLayout = width < $dc61fe5bc723aa83$export$a24d4999f7186564; // In the small-height layout, if there's an image, its width is fixed:
    let imageWidth;
    if (height === (0, $4cOi8.Height).SMALL && (layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT || layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_RIGHT)) {
        if (width >= 1024) imageWidth = 514;
        else if (width >= 768) imageWidth = 186;
        else if (width > $dc61fe5bc723aa83$export$a24d4999f7186564) imageWidth = 140;
        else imageWidth = 84;
    }
    const getFlexDirection = ()=>{
        if (showVerticalLayout) return layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT ? 'column' : 'column-reverse';
        return layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT ? 'row' : 'row-reverse';
    };
    return layout === $dc61fe5bc723aa83$var$FRAME_ABOVE_IMAGE ? /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        style: {
            height: `${$dc61fe5bc723aa83$var$spotlightToCssHeight(height)}px`
        },
        className: (0, $gMc0m.default)([
            $dc61fe5bc723aa83$var$gridStyles.grid
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $dc61fe5bc723aa83$var$gridStyles.fullImage,
            hasRoundedCorners && $dc61fe5bc723aa83$var$gridStyles.roundedBorderRadius
        ]),
        "data-vc": "Jtg-VRab"
    }, image), /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundColor: backgroundColor
        },
        className: (0, $gMc0m.default)([
            $dc61fe5bc723aa83$var$gridStyles.frameChildren,
            $dc61fe5bc723aa83$var$gridStyles[$dc61fe5bc723aa83$export$e2db3adb05a4002(width)]
        ])
    }, children)) : /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        style: {
            backgroundColor: backgroundColor,
            height: `${$dc61fe5bc723aa83$var$spotlightToCssHeight(height)}px`,
            flexDirection: getFlexDirection(),
            borderRadius: hasRoundedCorners ? "var(--ds-radius-xlarge, 12px)" : 0
        },
        className: (0, $gMc0m.default)([
            $dc61fe5bc723aa83$var$percentageStyles.flex,
            !hideExtensionBorders && $dc61fe5bc723aa83$var$percentageStyles.borderStyle
        ])
    }, layout !== $dc61fe5bc723aa83$var$NO_IMAGE_BACKGROUND && /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            flexBasis: imageWidth || `${imageWidthPercentage * 100}%`,
            height: showVerticalLayout ? `${$dc61fe5bc723aa83$var$spotlightToCssHeight(height) * imageWidthPercentage}px` : '100%'
        },
        className: (0, $gMc0m.default)([
            $dc61fe5bc723aa83$var$percentageStyles.imageSide
        ])
    }, image), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $dc61fe5bc723aa83$var$percentageStyles.childrenSide
        ])
    }, children));
}
module.exports["VERTICAL_MAX_WIDTH"] = $dc61fe5bc723aa83$export$a24d4999f7186564;
module.exports["SpotlightLayout"] = $dc61fe5bc723aa83$export$40cf3f2715085991;

});


//# sourceMappingURL=cards-extension.321cc7e4.js.map
